<div
  class="box"
  style="margin-right: 10px; margin-top: -20px; z-index: 10; width: 672px">
  <div class="box-body">
    <span
      style="line-height: 35px;  font-size: 17px; color: #444;margin-top: -50px"
      ><i class="fa fa-gear"></i> Paramétrage des alertes</span>
    <div class="nav-tabs-custom" style="margin-top: 20px">
      <ul class="nav nav-tabs pull-right" >
        <li  class="dropdown" style="margin-right: 70px;border-radius: 15px;background-color: #a4c1d1;border: none">
          <a style="border-radius: 15px"
             class="dropdown-toggle"
            data-toggle="dropdown"
            aria-expanded="true">
            <i class="fa fa-plus-circle Plus"></i>
          </a>
          <ul class="dropdown-menu">
            <li
              routerLinkActive="active"
              routerLink="/client/alertManagement/alertSettings/speedCartoSetting">
              <a >Vitesse Carto</a>
            </li>
            <li
              routerLinkActive="active"
              routerLink="/client/alertManagement/alertSettings/documentSetting">
              <a>Documents de circulations</a>
            </li>
            <li
              routerLinkActive="active"
              routerLink="/client/alertManagement/alertSettings/oilChangeSetting">
              <a>Vidange</a>
            </li>
            <li
              routerLinkActive="active"
              routerLink="/client/alertManagement/alertSettings/tireSetting">
              <a>Pneus</a>
            </li>
            <li
              routerLinkActive="active"
              routerLink="/client/alertManagement/alertSettings/batteriesSetting"
            >
              <a>Gestion Batterie</a>
            </li>
            <li
              routerLinkActive="active"
              routerLink="/client/alertManagement/alertSettings/batterySetting"
            >
              <a
                ><!--<i class="fa fa-battery-full"></i>-->
                Alimentation Batterie</a
              >
            </li>
            <!-- <li routerLinkActive="active" routerLink="/client/alertManagement/alertSettings/consumptionSetting"><a><i class="fa fa-car"></i> Consommation</a></li> -->

            <!--<li routerLinkActive="active" routerLink="/client/alertManagement/alertSettings/brakeSetting"><a>Freins</a></li>-->
            <li
              routerLinkActive="active"
              routerLink="/client/alertManagement/alertSettings/activitySetting"
            >
              <a>Heure d'activité continue</a>
            </li>
            <li
              routerLinkActive="active"
              routerLink="/client/alertManagement/alertSettings/activityHourSetting"
            >
              <a>Heure de travail</a>
            </li>
            <li
              routerLinkActive="active"
              routerLink="/client/alertManagement/alertSettings/chomage"
            >
              <a>Retard d'affectation</a>
            </li>
            <li
              routerLinkActive="active"
              routerLink="/client/alertManagement/alertSettings/chargement"
            >
              <a>Retard chargement</a>
            </li>
            <li
              routerLinkActive="active"
              routerLink="/client/alertManagement/alertSettings/remisageSetting"
            >
              <a>Remisage</a>
            </li>
            <li
              routerLinkActive="active"
              routerLink="/client/alertManagement/alertSettings/approFuelSetting"
            >
              <a>Approvisionnement carburant</a>
            </li>
            <li
              routerLinkActive="active"
              routerLink="/client/alertManagement/alertSettings/activityDailySetting"
            >
              <a>Planification</a>
            </li>
          </ul>
        </li>
        <!--<li routerLinkActive="active" routerLink="/client/alertManagement/alertSettings/towingSetting"><a>Remorquage</a></li>-->
        <li class="down-a"
          routerLinkActive="active"
          routerLink="/client/alertManagement/alertSettings/speedSetting"
        >
          <a  class="down-a"  > Vitesse</a>
        </li>
        <li class="down-a"
          routerLinkActive="active"
          routerLink="/client/alertManagement/alertSettings/noPoiSetting"
        >
          <a   class="down-a" >Arrêt Non P.O.I</a>
        </li>
        <li class="down-a"
          routerLinkActive="active"
          routerLink="/client/alertManagement/alertSettings/poiSetting"
        >
          <a   >Arrêt P.O.I</a>
        </li>
        <li  class="down-a"
            routerLinkActive="active"
          routerLink="/client/alertManagement/alertSettings/ignitionSetting"
        >
          <a  >Contact v = 0</a>
        </li>
        <li  class="down-a"
          routerLinkActive="active"
          routerLink="/client/alertManagement/alertSettings/zoneSetting"
        >
          <a  class="down-a" >Zones</a>
        </li>
      </ul>
      <div class="tab-content">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>
